module.exports = "<div class=\"card\"> \n  <div class=\"chart-container\">\n    <div class=\"skeleton-card\">\n      <!-- Left Text Skeleton -->\n      <div class=\"skeleton-text\">\n        <div class=\"skeleton-line\"></div>\n        <div class=\"skeleton-line\"></div>\n        <div class=\"skeleton-line\"></div>\n      </div>\n    \n      <!-- Right Pie Chart Skeleton -->\n      <div class=\"skeleton-pie-container\">\n        <div class=\"skeleton-pie\"></div>\n      </div>\n    </div>\n    \n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-ghost-card-module/pie-chart-ghost-card/pie-chart-ghost-card.component.html
// module id = 1023
// module chunks = 6